var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "md:px-80 slideout-menu py-60 md:py-120 flex flex-col items-start px-20"
    },
    [
      _c(
        "div",
        { staticClass: "lg:hidden flex flex-col items-start mb-32" },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.generalData
        ? _c(
            "div",
            { staticClass: "lg:hidden" },
            [
              _c(
                "search-bar",
                {
                  staticClass: "mb-32",
                  attrs: {
                    placeholder: _vm.generalData.menu_data.search_placeholder,
                    open: true
                  }
                },
                [
                  _c("div", { staticClass: "text-blue mr-16" }, [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(_vm.svg("search", "fill-current "))
                      }
                    })
                  ])
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.menu
        ? _c(
            "div",
            { staticClass: "md:mb-80 flex flex-col items-start mb-32" },
            [
              _vm._l(_vm.menu, function(item, index) {
                return [
                  item.page != null && item.show_in_menu
                    ? _c("a", {
                        key: index,
                        staticClass: "text-20 last:mb-0 mb-16 font-bold",
                        attrs: { href: "" + item.page.relative_link },
                        domProps: { innerHTML: _vm._s(item.name) }
                      })
                    : _vm._e()
                ]
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.generalData
        ? _c("div", { staticClass: "flex flex-col items-start" }, [
            _c(
              "a",
              {
                staticClass:
                  "opacity-70 hover:opacity-100 flex items-center mb-16 text-gray-800",
                attrs: { href: "mailto:" + _vm.generalData.contact_email }
              },
              [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.svg("mail", "fill-current mr-8 w-14 h-14 mt-1")
                    )
                  }
                }),
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.generalData.contact_email) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass:
                  "opacity-70 hover:opacity-100 flex items-center mb-16 text-gray-800",
                attrs: { href: "/info" }
              },
              [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.svg("headphones", "fill-current mr-8 w-14 h-14 mt-1")
                    )
                  }
                }),
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.generalData.menu_data.customer_service_label) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass:
                  "opacity-70 hover:opacity-100 flex items-center text-gray-800",
                attrs: {
                  href: _vm.generalData.facebook_url,
                  target: "_blank",
                  rel: "noopener"
                }
              },
              [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.svg("facebook", "fill-current mr-8 w-14 h-14 mt-1")
                    )
                  }
                }),
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.generalData.menu_data.facebook_label) +
                    "\n        "
                )
              ]
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }